import React from 'react';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import ConsultantProfileContainer from './ConsultantProfile';
import rootReducer from '../../reducers';
var store = createStore(rootReducer);
function ConsultantProfile(props) {
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(ConsultantProfileContainer, props));
}
export default ConsultantProfile;